import { Route, Routes } from 'react-router-dom';

import { PUBLIC_URL } from 'constants/main';
import Page from 'pages/Page';

import NotFoundPage from 'pages/NotFoundPage';
import { SingleTemplatePage, TemplateCategoriesPage } from 'templates/pages';

const RoutesComponent = () => (
  <Routes>
    <Route path={`${PUBLIC_URL}/`} element={<Page />}>
      <Route index element={<Page />} />
      <Route path=":lang" element={<Page />} />
      <Route path=":lang/:page" element={<Page />} />
      <Route path=":lang/:page/*" element={<Page />} />
      <Route path="*" element={<Page />} />
    </Route>

    <Route path="/templates/:category" element={<TemplateCategoriesPage />} />
    <Route path="/template/:templateId" element={<SingleTemplatePage />} />
    <Route path="/templates/:category/:subCategory" element={<TemplateCategoriesPage />} />

    <Route path={`${PUBLIC_URL}/:lang/not-found`} element={<NotFoundPage />} />
    <Route path={`${PUBLIC_URL}/not-found`} element={<NotFoundPage />} />
  </Routes>
);

export default RoutesComponent;
